import React, { createContext, useState } from "react"
import CameraImage from "../assets/images/cameras/camera.jpeg"

export const AuthContext = createContext();

const AuthContextProvider = ({ children }) => {
  const [auth, setAuth] = useState({});
  const[Cameras, setCameras]= useState([
   
  ])
 

  return (
    <AuthContext.Provider
      value={{
        auth,
        setAuth,
        Cameras,
        setCameras
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContextProvider;
